(function () {
    //console.log("parallax loaded")

    window.onscroll = (event) => {
        const parallax = document.querySelector(".parallax > div")
        const banner = document.querySelector(".banner")
        const bannerHeight = banner == null ? 0 : banner.offsetHeight;

        const footer = document.querySelector("footer");
        const body = document.body,
            html = document.documentElement;

        const height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
        const maxHeight = Math.min(898, height);

        if (parallax) {
            if (window.scrollY > 1000) {
                parallax.style.backgroundAttachment = "initial"
                parallax.style.height = maxHeight + "px"
                parallax.style.top = (1000 - bannerHeight) + "px"
            } else {
                parallax.style.backgroundAttachment = null
                parallax.style.height = null
                parallax.style.top = null
            }
        }
        const parallax2Container = document.querySelector(".parallax2")

        if (parallax2Container) {
            const parallax2 = document.querySelector(".parallax2 > div")
            if (window.scrollY >= 3000 && window.scrollY <= 5000) {
                parallax2Container.classList.remove("hidden")
                parallax2Container.classList.add("visible")
            } else {
                parallax2Container.classList.remove("visible")
                parallax2Container.classList.add("hidden")
            }
        }
        //handleFooterImage()
    };

    //function handleFooterImage() {
    //    const footer = document.querySelector("footer");
    //    const fImageContainer = document.querySelector("footer .f-image");
    //    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    //    const fImage = vWidth >= 1280 ? document.querySelector("footer .f-image img") : document.querySelector("footer .f-image img.mob");
    //    if (fImageContainer && fImageContainer.style) {
    //        fImageContainer.style.top = "0";
    //    }

    //    if (footer && fImage) {
    //        const fRect = footer.getBoundingClientRect()
    //        const fImageRect = fImage.getBoundingClientRect()
    //        const fImageHeight = fImageRect.bottom - fImageRect.top;
    //        const vHeight = window.innerHeight || document.documentElement.clientHeight;
    //        if (vHeight > fRect.top) {
    //            const amountDisplaying = vHeight - fRect.top;
    //            if (amountDisplaying > fImageHeight) {
    //                const imagePos = amountDisplaying - fImageHeight;
    //                fImageContainer.style.top = imagePos + "px";
    //            }
                
    //        }
    //    }
    //}


   

})();